// extracted by mini-css-extract-plugin
export default {"header":"styles-module__header__src-labstep-web-core-Table-Simple-Header-_cS2qP"};